export default "__VITE_ASSET__Czats8W9__"